import { Api } from 'models/services/api';
import { UpdateBusinessQuery } from 'models/services/graphql';

import { BusinessData, BusinessDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: BusinessDataToSave;
};

const RequestQuery = `
  mutation UpdateBusiness($id: ID!, $input: BusinessInput!) {
    ${UpdateBusinessQuery}
  }
`;

type ResponseData = {
  data: {
    updateBusiness: BusinessData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: BusinessData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateBusiness;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };